module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Muhen_AG-517335d7db81925efd3a01fb277d09d6.svg";